(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 8312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(5883);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5883:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 18 modules
var esm = __webpack_require__(632);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./src/hooks/useHostedSession/index.ts + 5 modules
var useHostedSession = __webpack_require__(4287);
// EXTERNAL MODULE: ./src/components/index.ts + 139 modules
var components = __webpack_require__(7624);
// EXTERNAL MODULE: ./node_modules/@awell-health/ui-library/dist/index.js
var dist = __webpack_require__(3066);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.mjs + 1 modules
var react_toastify_esm = __webpack_require__(1444);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/ReactToastify.css
var ReactToastify = __webpack_require__(993);
// EXTERNAL MODULE: ./src/assets/logo.svg
var logo = __webpack_require__(8516);
var logo_default = /*#__PURE__*/__webpack_require__.n(logo);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/types/generated/types-orchestration.tsx
var types_orchestration = __webpack_require__(5852);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(6486);
// EXTERNAL MODULE: ./src/hooks/useSessionStorage/index.ts
var useSessionStorage = __webpack_require__(2107);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/services/ErrorReporter/index.ts + 1 modules
var ErrorReporter = __webpack_require__(8644);
// EXTERNAL MODULE: ./src/services/ErrorReporter/addSentryBreadcrumb.ts
var addSentryBreadcrumb = __webpack_require__(2041);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(655);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/globals/index.js + 4 modules
var globals = __webpack_require__(8287);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/context/ApolloContext.js
var context_ApolloContext = __webpack_require__(5317);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/react/context/ApolloProvider.js




var ApolloProvider = function (_a) {
    var client = _a.client, children = _a.children;
    var ApolloContext = (0,context_ApolloContext/* getApolloContext */.K)();
    var parentContext = react.useContext(ApolloContext);
    var context = react.useMemo(function () {
        return (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, parentContext), { client: client || parentContext.client });
    }, [parentContext, client]);
    (0,globals/* invariant */.kG)(context.client, 46);
    return (react.createElement(ApolloContext.Provider, { value: context }, children));
};
//# sourceMappingURL=ApolloProvider.js.map
// EXTERNAL MODULE: ./src/services/graphql/index.ts + 2 modules
var graphql = __webpack_require__(4342);
;// CONCATENATED MODULE: ./src/types/generated/fragment-types.ts
/* eslint-disable */ var result = {
    "possibleTypes": {
        "PaginationAndSortingPayload": [
            "ActivitiesPayload",
            "OrchestrationFactsPayload",
            "PathwaysPayload",
            "PatientsPayload",
            "PublishedPathwayDefinitionsPayload"
        ],
        "Payload": [
            "ActionPayload",
            "AddIdentifierToPatientPayload",
            "AddTrackPayload",
            "ApiCallPayload",
            "ApiCallsPayload",
            "BaselineInfoPayload",
            "CalculationResultsPayload",
            "CancelScheduledTracksPayload",
            "ChecklistPayload",
            "ClinicalNotePayload",
            "CompleteExtensionActivityPayload",
            "CreatePatientPayload",
            "CurrentUserPayload",
            "ElementsPayload",
            "EmptyPayload",
            "EmrReportPayload",
            "EvaluateFormRulesPayload",
            "ExtensionActivityRecordPayload",
            "FormPayload",
            "FormResponsePayload",
            "FormsPayload",
            "HostedPagesLinkPayload",
            "HostedSessionActivitiesPayload",
            "HostedSessionPayload",
            "MarkMessageAsReadPayload",
            "MessagePayload",
            "OrchestrationFactsPromptPayload",
            "PathwayDataPointDefinitionsPayload",
            "PathwayPayload",
            "PatientDemographicsPayload",
            "PatientPathwaysPayload",
            "PatientPayload",
            "RetryApiCallPayload",
            "RetryWebhookCallPayload",
            "ScheduleTrackPayload",
            "ScheduledStepsPayload",
            "ScheduledTracksPayload",
            "SearchPatientsPayload",
            "StakeholdersPayload",
            "StartHostedActivitySessionPayload",
            "StartHostedPathwaySessionFromLinkPayload",
            "StartHostedPathwaySessionPayload",
            "StartPathwayPayload",
            "StartPathwayWithPatientIdentifierPayload",
            "StopTrackPayload",
            "SubmitChecklistPayload",
            "SubmitFormResponsePayload",
            "TracksPayload",
            "UpdatePatientDemographicsQueryPayload",
            "UpdatePatientLanguagePayload",
            "UpdatePatientPayload",
            "WebhookCallPayload",
            "WebhookCallsPayload"
        ]
    }
};
/* harmony default export */ var fragment_types = (result);

// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(4487);
;// CONCATENATED MODULE: ./src/components/GraphqlWrapper.tsx






var onError = function(param) {
    var operation = param.operation, networkError = param.networkError;
    if (networkError) {
        esm_exports/* captureException */.Tb(networkError, {
            contexts: {
                graphql: {
                    operation: operation.operationName,
                    variables: JSON.stringify(operation.variables),
                    result: networkError.name === "ServerError" ? JSON.stringify(networkError.result) : undefined,
                    statusCode: networkError.name === "ServerError" ? JSON.stringify(networkError.statusCode) : undefined,
                    bodyText: networkError.name === "ServerParseError" ? JSON.stringify(networkError.bodyText) : undefined
                }
            }
        });
    }
};
var GraphqlWrapper = function(param) {
    var children = param.children;
    // const { infoLog, errorLog } = useLogging()
    var client = (0,graphql/* createClient */.eI)({
        httpUri: "https://api.development.awellhealth.com/orchestration/graphql",
        wsUri: "wss://api.development.awellhealth.com/orchestration/subscriptions",
        onNetworkError: onError,
        cacheConfig: {
            possibleTypes: fragment_types.possibleTypes
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ApolloProvider, {
        client: client,
        children: children
    });
};

// EXTERNAL MODULE: ./src/services/authentication/index.ts + 3 modules
var authentication = __webpack_require__(8803);
;// CONCATENATED MODULE: ./src/components/AuthGuard.tsx



var AuthGuard = function(param) {
    var children = param.children;
    var error = (0,authentication/* useAuthentication */.J)().error;
    if (error) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
            children: [
                "ERROR: ",
                JSON.stringify(error)
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: children
    });
};
AuthGuard.displayName = "AuthGuard";

// EXTERNAL MODULE: ./src/components/NoSSR.tsx
var NoSSR = __webpack_require__(8264);
// EXTERNAL MODULE: ./src/components/ErrorBoundary/index.ts + 11 modules
var ErrorBoundary = __webpack_require__(6865);
;// CONCATENATED MODULE: ./src/layouts/HostedSessionLayout.tsx






var HostedSessionLayout = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(authentication/* AuthenticationProvider */.i, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthGuard, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GraphqlWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NoSSR/* NoSSRComponent */.R, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* ErrorBoundary */.S, {
                            children: children
                        })
                    })
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/layouts/index.tsx


// EXTERNAL MODULE: ./src/components/SuccessPage/successPage.module.css
var successPage_module = __webpack_require__(9354);
var successPage_module_default = /*#__PURE__*/__webpack_require__.n(successPage_module);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/assets/success.svg
var success = __webpack_require__(4608);
var success_default = /*#__PURE__*/__webpack_require__.n(success);
;// CONCATENATED MODULE: ./src/components/SuccessPage/SuccessPage.tsx





var SuccessPage = function(param) {
    var _redirect = param.redirect, redirect = _redirect === void 0 ? false : _redirect;
    var t = (0,esm/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (successPage_module_default()).success_page,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (successPage_module_default()).success_icon,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: (success_default()),
                    alt: "",
                    width: 64,
                    height: 64
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (successPage_module_default()).success_text_title,
                children: t("session.all_activities_completed_title")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (successPage_module_default()).success_text_subtitle,
                children: redirect ? t("session.redirecting_to_next_page") : t("session.all_activities_completed_subtitle")
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/SuccessPage/index.ts


// EXTERNAL MODULE: ./src/components/SessionExpiredPage/sessionExpiredPage.module.css
var sessionExpiredPage_module = __webpack_require__(4648);
var sessionExpiredPage_module_default = /*#__PURE__*/__webpack_require__.n(sessionExpiredPage_module);
// EXTERNAL MODULE: ./src/assets/warning.svg
var warning = __webpack_require__(3056);
var warning_default = /*#__PURE__*/__webpack_require__.n(warning);
;// CONCATENATED MODULE: ./src/components/SessionExpiredPage/SessionExpiredPage.tsx





var SessionExpiredPage = function(param) {
    var _redirect = param.redirect, redirect = _redirect === void 0 ? false : _redirect;
    var t = (0,esm/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (sessionExpiredPage_module_default()).expired_page,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (sessionExpiredPage_module_default()).expired_icon,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: (warning_default()),
                    alt: "",
                    width: 84,
                    height: 84
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (sessionExpiredPage_module_default()).expired_text_title,
                children: t("session.expired_title")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (sessionExpiredPage_module_default()).expired_text_subtitle,
                children: redirect ? t("session.redirecting_to_next_page") : t("session.expired_subtitle")
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/SessionExpiredPage/index.ts


// EXTERNAL MODULE: ./src/config/awell.ts
var awell = __webpack_require__(3248);
// EXTERNAL MODULE: ./src/hooks/useLogging/index.ts + 1 modules
var useLogging = __webpack_require__(4128);
// EXTERNAL MODULE: ./src/hooks/useLogging/types.ts
var types = __webpack_require__(5064);
;// CONCATENATED MODULE: ./pages/index.tsx
/* eslint-disable react-hooks/exhaustive-deps */ 





















// Handles Session URLs generated by Start Hosted Pathway/Activities Session mutation
// i.e. https://goto.awell.health/en?sessionId=e-Dmjxm3E5AW
var Home = function() {
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref = (0,useHostedSession/* useHostedSession */.H)(), loading = ref.loading, session = ref.session, branding = ref.branding, theme = ref.theme, error = ref.error, refetch = ref.refetch;
    var ref1 = (0,useSessionStorage/* useSessionStorage */.X)("accessToken", ""), removeAccessToken = ref1.removeItem;
    var router = (0,next_router.useRouter)();
    var infoLog = (0,useLogging/* useLogging */.K)().infoLog;
    var ref2 = (0,react.useState)(false), isCloseHostedSessionModalOpen = ref2[0], setIsCloseHostedSessionModalOpen = ref2[1];
    var redirectAfterSession = function(url) {
        // adding 2 second delay so users are aware of the redirection and we don't change the page abruptly
        setTimeout(function() {
            removeAccessToken();
            router.push(url);
        }, 2000);
        // add sentry breadcrumb if redirect takes more than 10 seconds
        setTimeout(function() {
            (0,ErrorReporter/* addSentryBreadcrumb */.b)({
                category: addSentryBreadcrumb/* BreadcrumbCategory.SLOW_REDIRECT */.j.SLOW_REDIRECT,
                data: {
                    session: session,
                    message: "Redirect took at least 10 seconds"
                }
            });
        }, 10000);
        // add sentry breadcrumb if redirect takes more than 15 seconds
        setTimeout(function() {
            (0,ErrorReporter/* addSentryBreadcrumb */.b)({
                category: addSentryBreadcrumb/* BreadcrumbCategory.SLOW_REDIRECT */.j.SLOW_REDIRECT,
                data: {
                    session: session,
                    message: "Redirect took at least 15 seconds"
                }
            });
        }, 15001);
    };
    var onOpenCloseHostedSessionModal = function() {
        setIsCloseHostedSessionModalOpen(true);
    };
    var onCloseHostedSessionModal = function() {
        setIsCloseHostedSessionModalOpen(false);
    };
    var onCloseHostedSession = function() {
        (0,ErrorReporter/* addSentryBreadcrumb */.b)({
            category: addSentryBreadcrumb/* BreadcrumbCategory.SESSION_CANCEL */.j.SESSION_CANCEL,
            data: session
        });
        var ref;
        router.push((ref = session === null || session === void 0 ? void 0 : session.cancel_url) !== null && ref !== void 0 ? ref : "https://awell.health");
    };
    var shouldRedirect = (session === null || session === void 0 ? void 0 : session.status) === types_orchestration/* HostedSessionStatus.Completed */.Q5.Completed && !(0,lodash.isNil)(session === null || session === void 0 ? void 0 : session.success_url) || (session === null || session === void 0 ? void 0 : session.status) === types_orchestration/* HostedSessionStatus.Expired */.Q5.Expired && !(0,lodash.isNil)(session === null || session === void 0 ? void 0 : session.cancel_url);
    var hideCloseButton = (session === null || session === void 0 ? void 0 : session.status) !== types_orchestration/* HostedSessionStatus.Active */.Q5.Active && !shouldRedirect || !theme.layout.showCloseButton;
    (0,react.useEffect)(function() {
        if ((0,lodash.isNil)(session === null || session === void 0 ? void 0 : session.status)) {
            (0,ErrorReporter/* addSentryBreadcrumb */.b)({
                category: addSentryBreadcrumb/* BreadcrumbCategory.GENERIC */.j.GENERIC,
                data: {
                    session: session,
                    message: "Session status is null"
                }
            });
            return;
        }
        if (false) {}
        switch(session === null || session === void 0 ? void 0 : session.status){
            case types_orchestration/* HostedSessionStatus.Completed */.Q5.Completed:
                infoLog({
                    msg: "Hosted session is completed",
                    session: session
                }, types/* LogEvent.SESSION_COMPLETED */.g.SESSION_COMPLETED);
                (0,ErrorReporter/* addSentryBreadcrumb */.b)({
                    category: addSentryBreadcrumb/* BreadcrumbCategory.SESSION_COMPLETE */.j.SESSION_COMPLETE,
                    data: {
                        session: session
                    }
                });
                if (shouldRedirect) {
                    redirectAfterSession(session.success_url);
                }
                return;
            case types_orchestration/* HostedSessionStatus.Expired */.Q5.Expired:
                infoLog({
                    msg: "Hosted session is expired",
                    session: session
                }, types/* LogEvent.SESSION_EXPIRED */.g.SESSION_EXPIRED);
                (0,ErrorReporter/* addSentryBreadcrumb */.b)({
                    category: addSentryBreadcrumb/* BreadcrumbCategory.SESSION_EXPIRE */.j.SESSION_EXPIRE,
                    data: {
                        session: session
                    }
                });
                if (shouldRedirect) {
                    redirectAfterSession(session.cancel_url);
                }
                return;
            default:
                infoLog({
                    msg: "Hosted session is ongoing",
                    session: session
                }, types/* LogEvent.SESSION_ONGOING */.g.SESSION_ONGOING);
                return;
        }
    }, [
        session
    ]);
    var renderSessionContent = function() {
        if (session) {
            switch(session.status){
                case types_orchestration/* HostedSessionStatus.Active */.Q5.Active:
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ActivitiesContainer */.nI, {});
                case types_orchestration/* HostedSessionStatus.Completed */.Q5.Completed:
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SuccessPage, {
                        redirect: shouldRedirect
                    });
                case types_orchestration/* HostedSessionStatus.Expired */.Q5.Expired:
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SessionExpiredPage, {
                        redirect: shouldRedirect
                    });
            }
        } else {
            return null;
        }
    };
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* LoadingPage */.h2, {
            showLogoBox: true
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: (0,lodash.defaultTo)(branding === null || branding === void 0 ? void 0 : branding.hosted_page_title, t("seo.title"))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: t("seo.title")
                    }, "title"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: t("seo.description")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ThemeProvider, {
                accentColor: (branding === null || branding === void 0 ? void 0 : branding.accent_color) || awell/* AWELL_BRAND_COLOR */.V,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist.HostedPageLayout, {
                    logo: theme.layout.showLogo ? (0,lodash.defaultTo)(branding === null || branding === void 0 ? void 0 : branding.logo_url, (logo_default())) : undefined,
                    onCloseHostedPage: onOpenCloseHostedSessionModal,
                    hideCloseButton: hideCloseButton,
                    children: [
                        renderSessionContent(),
                        error && /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ErrorPage */.mf, {
                            title: error === "UNAUTHORIZED" ? t("session.session_completed_or_expired") : t("session.loading_error"),
                            onRetry: refetch
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_toastify_esm/* ToastContainer */.Ix, {
                            position: "bottom-right",
                            newestOnTop: true,
                            closeOnClick: true,
                            pauseOnFocusLoss: true,
                            autoClose: 12000,
                            hideProgressBar: true,
                            draggable: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CloseHostedSessionModal */.iE, {
                            isModalOpen: isCloseHostedSessionModalOpen,
                            onCloseHostedSession: onCloseHostedSession,
                            onCloseModal: onCloseHostedSessionModal
                        })
                    ]
                })
            })
        ]
    });
};
Home.getLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HostedSessionLayout, {
        children: page
    });
};
var __N_SSG = true;
/* harmony default export */ var pages = (Home);


/***/ }),

/***/ 6865:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* reexport */ ErrorBoundary_ErrorBoundary; }
});

;// CONCATENATED MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_class_call_check.mjs
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
;// CONCATENATED MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_set_prototype_of.mjs
function setPrototypeOf(o, p) {
  setPrototypeOf = Object.setPrototypeOf || function setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return setPrototypeOf(o, p);
}

function _setPrototypeOf(o, p) {
  return setPrototypeOf(o, p);
}

;// CONCATENATED MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_inherits.mjs


function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(4251);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(2875);
;// CONCATENATED MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_is_native_reflect_construct.mjs
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () { }));
        return true;
    } catch (e) {
        return false;
    }
}
;// CONCATENATED MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_get_prototype_of.mjs
function getPrototypeOf(o) {
  getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return getPrototypeOf(o);
}

function _getPrototypeOf(o) {
  return getPrototypeOf(o);
}
;// CONCATENATED MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_assert_this_initialized.mjs
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

;// CONCATENATED MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_type_of.mjs
function _typeof(obj) {
    "@swc/helpers - typeof";
    return obj && obj.constructor === Symbol ? "symbol" : typeof obj;
};

;// CONCATENATED MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_possible_constructor_return.mjs



function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

;// CONCATENATED MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_create_super.mjs




function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived),
            result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/components/ErrorBoundary/error.module.css
var error_module = __webpack_require__(5898);
var error_module_default = /*#__PURE__*/__webpack_require__.n(error_module);
// EXTERNAL MODULE: ./src/components/ErrorPage/index.ts + 1 modules
var ErrorPage = __webpack_require__(6211);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(4487);
;// CONCATENATED MODULE: ./src/components/ErrorBoundary/reportErrorToSentry.ts

var reportErrorToSentry = function(error, errorInfo) {
    esm_exports/* withScope */.$e(function(scope) {
        scope.setContext("location", {
            location: window.location.pathname
        });
        esm_exports/* captureException */.Tb({
            error: error,
            errorInfo: errorInfo
        });
    });
};

// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 18 modules
var esm = __webpack_require__(632);
;// CONCATENATED MODULE: ./src/components/ErrorBoundary/ErrorBoundary.tsx
/* provided dependency */ var process = __webpack_require__(3454);











// https://reactjs.org/docs/error-boundaries.html
var ErrorBoundary = /*#__PURE__*/ function(_Component) {
    "use strict";
    _inherits(ErrorBoundary, _Component);
    var _super = _createSuper(ErrorBoundary);
    function ErrorBoundary(props) {
        _classCallCheck(this, ErrorBoundary);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            hasError: false,
            error: null,
            info: null
        };
        return _this;
    }
    var _proto = ErrorBoundary.prototype;
    _proto.componentDidCatch = function componentDidCatch(error, info) {
        this.setState(function(state) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: error,
                info: info
            });
        });
        reportErrorToSentry(error, info);
        var onError = this.props.onError;
        if (onError) onError(error);
    };
    _proto.render = function render() {
        var _state = this.state, hasError = _state.hasError, error = _state.error, info = _state.info;
        var children = this.props.children;
        var showStack =  false || process.env.NEXT_PUBLIC_AWELL_ENVIRONMENT === "staging";
        if (hasError) {
            if (showStack) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
                    style: {
                        whiteSpace: "pre-wrap"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ErrorPage/* ErrorPage */.m, {
                        title: this.props.t("errors.app_error"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: error === null || error === void 0 ? void 0 : error.toString()
                            }),
                            showStack && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: info === null || info === void 0 ? void 0 : info.componentStack
                            })
                        ]
                    })
                });
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorPage/* ErrorPage */.m, {
                title: this.props.t("errors.app_error")
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            id: "error-boundary",
            className: (error_module_default()).error,
            style: this.props.style,
            children: children
        });
    };
    ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError() {
        return {
            hasError: true
        };
    };
    return ErrorBoundary;
}(react.Component);
/* harmony default export */ var ErrorBoundary_ErrorBoundary = ((0,esm/* withTranslation */.Zh)()(ErrorBoundary));

;// CONCATENATED MODULE: ./src/components/ErrorBoundary/index.ts



/***/ }),

/***/ 5898:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"error":"error_error__RbXeS"};

/***/ }),

/***/ 4648:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"expired_page":"sessionExpiredPage_expired_page__pOnIi","expired_icon":"sessionExpiredPage_expired_icon__c7KCS","expired_text_title":"sessionExpiredPage_expired_text_title__KFtmK","expired_text_subtitle":"sessionExpiredPage_expired_text_subtitle__ljfEH"};

/***/ }),

/***/ 9354:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"success_page":"successPage_success_page__Ztjej","success_icon":"successPage_success_icon__m4YTX","success_text_title":"successPage_success_text_title__2vSnU","success_text_subtitle":"successPage_success_text_subtitle__YkoLq"};

/***/ }),

/***/ 993:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5443)


/***/ }),

/***/ 8516:
/***/ (function(module) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 4608:
/***/ (function(module) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNjQiIHZpZXdCb3g9IjAgMCA2NCA2NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjY0IiBoZWlnaHQ9IjY0IiByeD0iMzIiIGZpbGw9IiNFM0ZDRUYiLz4KPHBhdGggZD0iTTE5LjUgMzMuMjVMMjkuNSA0My4yNUw0NC41IDIwLjc1IiBzdHJva2U9IiMzNkIzN0UiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ 3056:
/***/ (function(module) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDEiIGhlaWdodD0iNDEiIHZpZXdCb3g9IjAgMCA0MSA0MSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yMi41NDYxIDMuODQ3NDdMMzYuNzQxMSAxOC4wNDI1QzM4LjA0OTUgMTkuMzUwOSAzOC4wNDk1IDIxLjQ3MjEgMzYuNzQxMSAyMi43ODA0TDIyLjU0NjEgMzYuOTc1NUMyMS4yMzc3IDM4LjI4MzggMTkuMTE2NSAzOC4yODM4IDE3LjgwODEgMzYuOTc1NUwzLjYxMzA5IDIyLjc4MDRDMi4zMDQ3NSAyMS40NzIxIDIuMzA0NzUgMTkuMzUwOSAzLjYxMzA5IDE4LjA0MjVMMTcuODA4MSAzLjg0NzQ3QzE5LjExNjUgMi41MzkxMyAyMS4yMzc3IDIuNTM5MTMgMjIuNTQ2MSAzLjg0NzQ3Wk0yMC4xNzcxIDI1LjAxOEMxOC45ODA2IDI1LjAxOCAxOC4wODMyIDI1LjkwMjUgMTguMDgzMiAyNy4wODE4QzE4LjA4MzIgMjguMzE0NiAxOC45NTM0IDI5LjE5OTEgMjAuMTc3MSAyOS4xOTkxQzIxLjM3MzYgMjkuMTk5MSAyMi4yNzEgMjguMzE0NiAyMi4yNzEgMjcuMTA4NkMyMi4yNzEgMjUuOTAyNSAyMS4zNzM2IDI1LjAxOCAyMC4xNzcxIDI1LjAxOFpNMjEuODUyMiAxMi4wMzU5SDE4LjUwMlYyMi4wODY2SDIxLjg1MjJWMTIuMDM1OVoiIGZpbGw9IiNFMkUyRTIiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yMC4xNzY5IDI1LjEwODZDMTguOTgwNCAyNS4xMDg2IDE4LjA4MyAyNS45OTMgMTguMDgzIDI3LjE3MjNDMTguMDgzIDI4LjQwNTIgMTguOTUzMiAyOS4yODk2IDIwLjE3NjkgMjkuMjg5NkMyMS4zNzM0IDI5LjI4OTYgMjIuMjcwOCAyOC40MDUyIDIyLjI3MDggMjcuMTk5MUMyMi4yNzA4IDI1Ljk5MyAyMS4zNzM0IDI1LjEwODYgMjAuMTc2OSAyNS4xMDg2Wk0yMS44NTIgMTIuMTI2NUgxOC41MDE4VjIyLjE3NzFIMjEuODUyVjEyLjEyNjVaIiBmaWxsPSIjODE4MTgxIi8+Cjwvc3ZnPg=="

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [210,662,122,891,915,502,127,774,888,179], function() { return __webpack_exec__(8312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);